import { createReducer } from '@reduxjs/toolkit';
import {
  getCustomerByIdSuccess,
  addEmploymentDetails,
  displayMarketingPreferenceModal,
  setAddressFieldErrors,
  clearAddressFieldErrors,
  setAddressValidation,
  dropInIncome,
  clearNewIncome,
  setFinancialCircumstanceValue
} from 'actionCreators/customer';
import { resetPrimaryApplicantInfo } from 'actionCreators/config';

const initialState = {
  customerInfo: null,
  marketing_preferences: null,
  displayMarketingPreferenceModal: false,
  issuesInPreviousAddress: false,
  addressFieldErrors: {},
  newIncome: 0,
  financialCircumstanceValue: null
};

const customerReducer = createReducer(initialState, (builder) => {
  builder.addCase(getCustomerByIdSuccess, (state, action) => {
    state.customerInfo = state.customerInfo
      ? { ...state.customerInfo, ...action.payload }
      : action.payload;
  });

  builder.addCase(addEmploymentDetails, (state, action) => {
    state.customerInfo
      ? (state.customerInfo.employment_details_extra = {
          employment_job_level: action?.payload?.employmentJobLevel,
          employment_industry: action?.payload?.employmentIndustry
        })
      : (state.customerInfo = {
          employment_details_extra: {
            employment_job_level: action?.payload?.employmentJobLevel,
            employment_industry: action?.payload?.employmentIndustry
          }
        });
  }),
    builder.addCase(resetPrimaryApplicantInfo, () => {
      return initialState;
    });

  builder.addCase('dip-customer/getPreferencesSuccess', (state, action) => {
    state.marketing_preferences = action.payload.marketing_preferences;
  });

  builder.addCase(displayMarketingPreferenceModal, (state, action) => {
    state.displayMarketingPreferenceModal = action.payload;
  });

  builder.addCase(setAddressFieldErrors, (state) => {
    state.issuesInPreviousAddress = true;
  });

  builder.addCase(clearAddressFieldErrors, (state) => {
    state.issuesInPreviousAddress = false;
  });

  builder.addCase(setAddressValidation, (state, action) => {
    state.addressFieldErrors = action.payload;
  });

  builder.addCase(dropInIncome, (state, action) => {
    state.newIncome = action.payload;
  });

  builder.addCase(setFinancialCircumstanceValue, (state, action) => {
    state.financialCircumstanceValue = action.payload;
  });

  builder.addCase(clearNewIncome, (state) => {
    state.newIncome = 0;
  });
});
export { customerReducer };
